import axios from 'axios';
import qs from 'qs';

// ------------------- COURSE API ------------------- //
export const createTraining = (data: any) =>
  axios.post('/api/v1/trainings', data);

export const updateTrainingById = (
  { trainingId, data }: { trainingId: string; data: any }, // NEW
) => axios.put(`/api/v1/trainings/${trainingId}`, data);

export const submitTraining = (trainingId: string) =>
  axios.post(`/api/v1/trainings/${trainingId}/submit`);

export const publishTraining = (trainingId: string) =>
  axios.post(`/api/v1/trainings/${trainingId}/publish`);

export const archiveTraining = (trainingId: string) =>
  axios.post(`/api/v1/trainings/${trainingId}/archive`);

export const restoreTraining = (trainingId: string) =>
  axios.post(`/api/v1/trainings/${trainingId}/restore`);

export const removeTraining = (trainingId: string) =>
  axios.delete(`/api/v1/trainings/${trainingId}`);

export const getTrainings = (params: Record<string, any>) =>
  axios.get(`/api/v1/trainings?${qs.stringify(params)}`);

export const getTrainingById = (trainingId: string) =>
  axios.get(`/api/v1/trainings/${trainingId}`);

export const getTrainingsStats = () => axios.get('/api/v1/trainings/stats');

export const getTrainingStats = (trainingId: string) =>
  axios.get(`/api/v1/trainings/${trainingId}/stats`);

export const getTrainingStatsByStudent = ({
  trainingId,
  studentId,
}: {
  trainingId: string;
  studentId: string;
}) => axios.get(`/api/v1/trainings/${trainingId}/stats/${studentId}`);

// ------------------- COURSE API ------------------- //

// ------------------- COURSE MODULES API ------------------- //

export const getTrainingModules = (trainingId: string) =>
  axios.get(`/api/v1/trainings/${trainingId}/modules`);

export const createTrainingModule = ({
  trainingId,
  data,
}: {
  trainingId: string;
  data: any;
}) => axios.post(`/api/v1/trainings/${trainingId}/modules`, data);

export const updateTrainingModuleById = ({
  trainingId,
  moduleId,
  data,
}: {
  trainingId: string;
  moduleId: string;
  data: any;
}) => axios.put(`/api/v1/trainings/${trainingId}/modules/${moduleId}`, data);

export const removeTrainingModuleById = ({
  trainingId,
  moduleId,
}: {
  trainingId: string;
  moduleId: string;
}) => axios.delete(`/api/v1/trainings/${trainingId}/modules/${moduleId}`);

export const reorderTrainingModules = ({
  trainingId,
  data,
}: {
  trainingId: string;
  data: any;
}) => axios.post(`/api/v1/trainings/${trainingId}/modules/reorder`, data);

// ------------------- COURSE MODULES API ------------------- //

// ------------------- COURSE LESSONS API ------------------- //

export const getTrainingLessons = (trainingId: string) =>
  axios.get(`/api/v1/trainings/${trainingId}/lessons`);

export const reorderTrainingLessons = ({
  trainingId,
  data,
}: {
  trainingId: string;
  data: any;
}) => axios.post(`/api/v1/trainings/${trainingId}/lessons/reorder`, data);

export const getTrainingLessonById = ({
  trainingId,
  lessonId,
}: {
  trainingId: string;
  lessonId: string;
}) => axios.get(`/api/v1/trainings/${trainingId}/lessons/${lessonId}`);

export const removeTrainingLessonById = ({
  trainingId,
  lessonId,
}: {
  trainingId: string;
  lessonId: string;
}) => axios.delete(`/api/v1/trainings/${trainingId}/lessons/${lessonId}`);
